/*! Copyright (c) Safe As Milk. All rights reserved. */
import { debounce } from "utils";

class ProductSingle extends HTMLElement {
    #resizeObserver;
    #variant;
    constructor() {
        super();
        this.updateGallery = this.updateGallery.bind(this);
        this.setPdpHeight = this.setPdpHeight.bind(this);
    }
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.productUrl = this.dataset.productUrl;
        this.sectionId = this.dataset.sectionId;
        this.updateGalleryOnVariantChange = this.hasAttribute("data-update-gallery-on-variant-change");
        if (this.updateGalleryOnVariantChange) {
            const variantSelectors = Array.from(this.querySelectorAll("variant-selects, variant-radios, variant-swatches, variant-mixed-inputs"));
            variantSelectors.forEach((selector => {
                selector.addEventListener("on:variant:change", this.updateGallery);
            }));
        }
        this.#moveModalsFromStickyScrollContainer();
        this.#resizeObserver = new ResizeObserver(debounce(this.setPdpHeight, 100));
        this.#resizeObserver.observe(this.querySelector(".product-single__box"));
    }
    disconnectedCallback() {
        if (this.updateGalleryOnVariantChange) {
            const variantSelectors = Array.from(this.querySelectorAll("variant-selects, variant-radios, variant-swatches, variant-mixed-inputs"));
            variantSelectors.forEach((selector => {
                selector.removeEventListener("on:variant:change", this.updateGallery);
            }));
            this.abortController = null;
        }
        this.#resizeObserver.disconnect();
    }
    setPdpHeight() {
        this.style.setProperty("--pdp-height", `${this.querySelector(".product-single__box").offsetHeight}px`);
    }
    async updateGallery({detail: {variant: variant}}) {
        const gallery = this.querySelector("media-gallery");
        if (!this.sectionId || !this.productUrl || !gallery) return;
        if (this.abortController) this.abortController.abort();
        let url = this.productUrl.includes("?") ? `${this.productUrl}&sections[]=${this.sectionId}` : `${this.productUrl}?sections[]=${this.sectionId}`;
        if (variant && !url.includes("variant=")) {
            url = `${url}&variant=${variant.id}`;
        }
        this.abortController = new AbortController;
        const data = await fetch(url, {
            signal: this.abortController.signal
        });
        const html = await data.json();
        const parsed = (new DOMParser).parseFromString(html[this.sectionId], "text/html");
        const newGallery = parsed.querySelector("media-gallery");
        gallery.replaceWith(newGallery);
        this.mediaGallery = newGallery;
        if (window.ShopifyXR) window.ShopifyXR.setupXRElements();
    }
    updateMedia() {
        if (!this.mediaGallery || !this.#variant.featured_media) return;
        const mediaId = this.#variant.featured_media.id;
        this.mediaGallery.goToSlide(mediaId);
    }
    set variant(variant) {
        this.#variant = variant;
        this.updateMedia();
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);

